import type { Editor, NodeEntry } from 'slate';

import { sumOf } from '../../util';
import type { RenderModelContentBlock, RenderModelTOC, TOCElement } from '../internal';
import { getOrCreateCachedRMBlockChild, Queries } from '../internal';

export function buildRenderModelTOC(
  editor: Editor,
  options: {
    containerWidthPx: number;
    isInHeaderFooter: boolean;
    pageNum: number;
    tocEntry: NodeEntry<TOCElement>;
  }
): RenderModelTOC {
  const { containerWidthPx, isInHeaderFooter, pageNum, tocEntry } = options;
  const [toc, tocPath] = tocEntry;
  const cachedKey = Queries.findKey(toc);
  const children: RenderModelContentBlock[] = toc.children.map((child, index) =>
    getOrCreateCachedRMBlockChild(editor, {
      containerWidthPx,
      isInHeaderFooter,
      nodeEntry: [child, [...tocPath, index]],
      pageNum,
    })
  );

  return {
    ...toc,
    children,
    heightPx: sumOf(children, 'heightPx'),
    key: cachedKey.id,
    relativePath: Queries.getPathRelativeToParent(tocPath),
  };
}
